// extracted by mini-css-extract-plugin
export default {"percentageDiscount":"s1nWp","complementary":"rvxEx","highlight":"ylNGP"};